// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"372":"21307407","446":"432dd3ed","542":"98ffe1b2","681":"39898d70"}[chunkId] + ".chunk.css";
};